import app from "@/main";

/**
 * Helper pour accéder au système de toast
 * Simplifie l'accès à app.config.globalProperties.$toast
 */
// On suppose que $toast expose les méthodes classiques d'un système de toast (success, error, info, warning)
type Toast = {
  success: (options?: Record<string, unknown>) => void;
  error: (options?: Record<string, unknown>) => void;
  info: (options?: Record<string, unknown>) => void;
  warning: (options?: Record<string, unknown>) => void;
};

export const useToast = (): Toast => app.config.globalProperties.$toast as Toast;

export default useToast;
